import { render, staticRenderFns } from "./KModal.vue?vue&type=template&id=c56e1430&scoped=true&"
import script from "./KModal.vue?vue&type=script&lang=js&"
export * from "./KModal.vue?vue&type=script&lang=js&"
import style0 from "./KModal.vue?vue&type=style&index=0&id=c56e1430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56e1430",
  null
  
)

export default component.exports